import graphql__9aa8b8704224cd08f0b6 from "./__generated__/PrivacyCookieConsentManagerQuery.graphql.js";import { graphql } from "react-relay";
import { connect } from "react-redux";

import AppQueryRenderer from "../AppQueryRenderer";
import PrivacyCookieConsent from "./PrivacyCookieConsent";

const PrivacyCookieConsentManager = props => {
  const { acceptsCookies } = props;

  if (acceptsCookies !== null) return null;

  return (
    <AppQueryRenderer
      query={PrivacyCookieConsentManagerQuery}
      component={PrivacyCookieConsent}
    />
  );
};

function mapStateToProps(state) {
  const { acceptsCookies } = state.viewer;

  return { acceptsCookies };
}

export default connect(mapStateToProps)(PrivacyCookieConsentManager);

const PrivacyCookieConsentManagerQuery = graphql__9aa8b8704224cd08f0b6;
